import { render, staticRenderFns } from "./AuditClaimsFilters.vue?vue&type=template&id=a54da6c8&scoped=true"
import script from "./AuditClaimsFilters.vue?vue&type=script&lang=js"
export * from "./AuditClaimsFilters.vue?vue&type=script&lang=js"
import style0 from "./AuditClaimsFilters.vue?vue&type=style&index=0&id=a54da6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54da6c8",
  null
  
)

export default component.exports